import { render, staticRenderFns } from "./referrer-actions-panel.vue?vue&type=template&id=46f05baa"
import script from "./referrer-actions-panel.vue?vue&type=script&lang=js"
export * from "./referrer-actions-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports